import InputFactory from "../../../../../components/InputFactory";

function Filters({ schema, onChangeFilter }) {
  const fields = {
    company: {
      label: "Enter Company Name",
      type: "String",
    },
    caseNumber: {
      label: "Enter Case No.",
      type: "String",
    },
    dateFiled: {
      label: "Enter Date Filed",
      type: "Date",
    },
  };

  const onChange = (type, value, field) => {
    // const value = e.target.value;
    onChangeFilter(type, value, field);
  };

  return (
    <div className="d-flex flex-column">
      <p className="m-0 fw-bold">Filters</p>
      <div className="d-flex gap-2 flex-column flex-md-row">
        {Object.entries(fields).map(([field, { label, type }]) => (
          <InputFactory
            key={field}
            placeholder={label}
            type={type}
            field={field}
            where={{}}
            onChange={(e) => onChange(type, e, field)}
          />
        ))}
      </div>
    </div>
  );
}

export default Filters;
